import { useMemo } from "react"
import { DetailFieldProps, FieldList, FieldType, StaticValue, UIPermission } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { usePricesHooks } from "../../../../operations"
import { Product, ProductPrices } from "../../../state/types"
import { ProductPriceList } from "../product-price-list/productPriceList"
import { useTaxLoaders } from "../../../../administration"
import { DiscountTable } from "../../../../common"
import { useSystemStateHooks } from "../../../../system"

type Props = {
  product: Product
  productPrices?: ProductPrices
}

export const ProductPricesDetail = (props: Props) => {
  const { product, productPrices } = props

  const { userHasPermission } = useSystemStateHooks()
  const pricesHooks = usePricesHooks()

  const taxLoaders = useTaxLoaders()

  const purchasePrice = useMemo(() => pricesHooks.product.purchasePrice(product.id), [product])
  const bonuses = useMemo(() => productPrices?.bonuses || [], [productPrices])
  const salePriceWithoutVat = useMemo(() => pricesHooks.product.basePrice(product.id), [product])
  const salePrice = useMemo(() => pricesHooks.product.basePrice(product.id, true), [product])
  const vatTaxId = useMemo(() => pricesHooks.product.vatTaxId(product.id), [product])
  
  const taxYieldStaticValue = useMemo(() => {
    const tax = taxLoaders().findTax(vatTaxId)
    return <StaticValue
      type={FieldType.PERCENTAGE}
      value={tax?.yield}
    />
  }, [product])

  const fields: DetailFieldProps[] = [
    {
      name: 'vatTaxId',
      type: FieldType.TABLE,
      table: TableName.TAXES,
      label: 'Condición de IVA',
      render: () => taxYieldStaticValue
    },
    {
      name: 'salePriceWithoutVat',
      type: FieldType.PRICE,
      label: 'Precio de Lista s/IVA',
      render: () => <StaticValue type={FieldType.PRICE} value={salePriceWithoutVat} />
    },
    {
      name: 'salePrice',
      type: FieldType.PRICE,
      label: 'Precio de Lista',
      render: () => <StaticValue type={FieldType.PRICE} value={salePrice} />
    }
  ]
  if (userHasPermission(UIPermission.READ_PRODUCT_PURCHASE_PRICE)) {
    const purchasePriceField = {
      name: 'purchasePrice',
      type: FieldType.PRICE,
      label: 'Precio de Compra',
      render: () => (
        <StaticValue
          type={FieldType.PRICE}
          value={purchasePrice}
        />
      )
    }
    fields.splice(0, 0, purchasePriceField)
    if (bonuses.length > 0) {
      const bonusesField = {
        name: 'bonuses',
        type: FieldType.TABLE,
        render: () => (
          <DiscountTable
            bonusesData={bonuses}
            readOnly
            space={6}
          />
        )
      }
      fields.splice(1, 0, bonusesField)
    }
  }
  

  return (
    <>
      <FieldList
        fields={fields}
      />
      <ProductPriceList product={product} />
    </>
  )
}
